// Packages
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Utils
import { getPresetSuffix } from "lib/utils/preset-util"

// Actions
import { selectSwatch } from "components/Stacker/actions/SwatchActions"

// Components
import LinkAdapter from "components/Stacker/components/LinkAdapter/LinkAdapter"

// Styles
import "./ProductImageTile.scss"
import { useDispatch } from "react-redux"

// this should hold the Product Details on PDP page.
function ProductImageTile({
  cropQuadrant,
  productImage,
  name,
  url,
  baseProductID,
  isLink = true,
  isDetailedView,
  isFreeGiftPromotionProduct,
  redirectionUrl,
  swatchId,
  handleClick,
}) {
  const dispatch = useDispatch()
  const setSwatchSelected = () => {
    dispatch(
      selectSwatch({
        baseProductCode: baseProductID,
        selectedVariantIndex: 0,
        selectedVariantCode: swatchId,
      })
    )
  }

  const customClickFunctions = () => {
    if (handleClick) {
      handleClick()
    }
    setSwatchSelected()
  }

  const renderProductImage = () => {
    const imagePreset = getPresetSuffix(cropQuadrant, "TILE_DESKTOP")
    if (isLink) {
      return (
        <LinkAdapter
          className="link"
          to={isFreeGiftPromotionProduct ? redirectionUrl : url}
          aria={{ label: name }}
          baseProduct={baseProductID}
          customClick={customClickFunctions}
          isHardPageLoad={isFreeGiftPromotionProduct}
        >
          <img src={`${productImage}${imagePreset}`} alt={name} />
        </LinkAdapter>
      )
    }
    return (
      <div className="link">
        <img src={`${productImage}${imagePreset}`} alt={name} />
      </div>
    )
  }

  return (
    <div
      className={classNames("ProductImageTile p-0", {
        "is-detailed-view": isDetailedView,
      })}
    >
      {renderProductImage()}
    </div>
  )
}

ProductImageTile.propTypes = {
  baseProductID: PropTypes.string.isRequired,
  cropQuadrant: PropTypes.string,
  name: PropTypes.string.isRequired,
  productImage: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isDetailedView: PropTypes.bool,
  swatchId: PropTypes.string.isRequired,
  isLink: PropTypes.bool,
  isFreeGiftPromotionProduct: PropTypes.bool,
  redirectionUrl: PropTypes.string,
  handleClick: PropTypes.func,
}

export default ProductImageTile
